(function () {
  const VP = (window.VolumePrices = window.VolumePrices || {});

  function getThresholds() {
    const row = document.querySelector('#volume-quantities-cells .volume-price-nested-headers tr');
    if (!row) return [1];

    const nums = Array.from(row.children)
      .map((c) => {
        const m = c.textContent.replace(/\s+/g, ' ').match(/(\d+)/);
        return m ? parseInt(m[1], 10) : null;
      })
      .filter((n) => Number.isFinite(n));

    const uniq = Array.from(new Set(nums)).sort((a, b) => a - b);
    return uniq.length ? uniq : [1];
  }

  VP.formatMoney = function (cents) {
    const fmt =
      window.shopMoneyFormat ||
      window.Shopify?.currency?.active_format ||
      window.theme?.moneyFormat ||
      '{{ amount }}';
    
    if (window.Shopify?.formatMoney) {
      return Shopify.formatMoney(cents, fmt);
    }

    const currency =
      window.Shopify?.currency?.active ||
      window.Shopify?.currency?.current ||
      document.documentElement.getAttribute('data-shop-currency');
      
    try {
      const locale = document.documentElement.lang || undefined;
      const formattedPrice = new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
      
      if (formattedPrice.startsWith(currency)) {
        return formattedPrice;
      }

      const currencySymbol = new Intl.NumberFormat(locale, { style: 'currency', currency }).formatToParts(cents / 100).find(part => part.type === 'currency').value;
      return currencySymbol + formattedPrice.replace(currencySymbol, '').trim();
      
    } catch {
      return (Math.round(cents) / 100).toFixed(2);
    }
  };

  VP.calculateUnitPrice = function (variantId, quantity) {
    const row = document.querySelector(
      `tr.variant-row[data-variant-id="${CSS.escape(String(variantId))}"]`
    );
    const base = parseInt(row?.dataset.variantPrice || '0', 10) || 0;

    const priceRow = row?.querySelector('.volume-price-nested-table tbody tr');
    if (!priceRow) return base;

    const thresholds = getThresholds(); // e.g., [1, 5, 10]
    // pick last threshold <= quantity
    let idx = 0;
    for (let i = 0; i < thresholds.length; i++) {
      if (quantity >= thresholds[i]) idx = i;
    }

    const cells = Array.from(priceRow.children);
    const td = cells[idx] || cells[0];
    const centsAttr = td?.getAttribute('data-price-cents');
    const cents = centsAttr ? parseFloat(centsAttr, 10) : NaN;

    return Number.isFinite(cents) ? cents : base;
  };

  VP.updateGrandTotal = function () {
    const table = document.getElementById('volume-price-table');
    if (!table) return;

    let total = 0;
    table.querySelectorAll('.quantity-input').forEach((input) => {
      const q = parseInt(input.value, 10) || 0;
      if (!q) return;

      const row = input.closest('tr.variant-row');
      const id = row?.dataset.variantId || input.dataset.variantId;
      if (!id) return;

      total += VP.calculateUnitPrice(id, q) * q;
    });

    const out = document.getElementById('grand-total');
    if (out) out.textContent = VP.formatMoney(total);
  };

  VP.refreshCartIcon = function () {
    fetch('/cart.js', { cache: 'no-store' })
      .then((r) => r.json())
      .then((cart) => {
        let bubble = document.querySelector('.cart-count-bubble');

        if (cart.item_count > 0) {
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            (
              document.querySelector('.header__icon--cart, .cart-icon, .cart-link, a[href*="/cart"]') ||
              document.querySelector('header [class*="cart"], header [href*="/cart"]')
            )?.appendChild(bubble);
          }
          if (bubble) {
            bubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>
              <span class="visually-hidden">${cart.item_count} ${cart.item_count == 1 ? 'item' : 'items'}</span>`;
            bubble.style.display = '';
          }
        } else if (bubble) {
          bubble.style.display = 'none';
        }
      })
      .catch(() => {});
  };

  VP.showToast = function (message, type = 'success') {
    const t = document.createElement('div');
    t.className = `cart-toast cart-toast--${type}`;
    t.setAttribute('role', type === 'success' ? 'status' : 'alert');
    t.setAttribute('aria-live', type === 'success' ? 'polite' : 'assertive');
    t.innerHTML = `<div class="cart-toast__content">
        <span class="cart-toast__icon">${type === 'success' ? '✓' : '⚠'}</span>
        <span class="cart-toast__message">${message}</span>
      </div>`;
    document.body.appendChild(t);
    setTimeout(() => t.classList.add('cart-toast--show'), 10);
    setTimeout(() => {
      t.classList.remove('cart-toast--show');
      setTimeout(() => t.remove(), 300);
    }, 1500);
  };

  VP.addAlltoCart = async function () {
    const table = document.getElementById('volume-price-table');
    if (!table) return;

    const updates = {};
    table.querySelectorAll('.quantity-input').forEach((input) => {
      const qty = parseInt(input.value, 10) || 0;
      const row = input.closest('tr.variant-row');
      const idRaw = input.dataset.variantId || row?.dataset.variantId;
      if (!idRaw) return;
      const id = String(idRaw).split('/').pop();
      updates[id] = qty;
    });

    const btn = table.querySelector('.add-all-to-cart-btn');
    if (!btn) return;

    const original = btn.textContent;
    btn.innerHTML = '<span class="cart-spinner"></span>';
    btn.disabled = true;
    btn.classList.add('loading');

    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });
      const data = await res.json();
      if (!res.ok || data.status >= 400) throw new Error('update failed');

      VP.showToast(window.QolLocales.toast_success, 'success');
      VP.refreshCartIcon?.();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'quick-order' } }));
    } catch (e) {
      VP.showToast(window.QolLocales.toast_error, 'error');
    } finally {
      btn.textContent = original;
      btn.disabled = false;
      btn.classList.remove('loading');
    }
  };

  function onClick(e) {
    const root = e.target.closest('#volume-price-table');
    if (!root) return;

    if (e.target.classList.contains('quantity-btn-inc')) {
      e.preventDefault();
      const input = e.target.previousElementSibling;
      const v = parseInt(input?.value, 10) || 0;
      input.value = v + 1;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      VP.updateGrandTotal();
    } else if (e.target.classList.contains('quantity-btn-dec')) {
      e.preventDefault();
      const input = e.target.nextElementSibling;
      const v = parseInt(input?.value, 10) || 0;
      input.value = Math.max(0, v - 1);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      VP.updateGrandTotal();
    } else if (e.target.classList.contains('add-all-to-cart-btn')) {
      e.preventDefault();
      VP.addAlltoCart();
    }
  }

  function onInput(e) {
    if (e.target.closest('#volume-price-table') && e.target.classList.contains('quantity-input')) {
      VP.updateGrandTotal();
    }
  }

  VP.initializeQuantityControls = function () {
    if (document.body.dataset.volumeHandlersInitialized === '1') return;
    document.body.dataset.volumeHandlersInitialized = '1';

    document.addEventListener('click', onClick);
    document.addEventListener('input', onInput);

    VP.updateGrandTotal();
  };

  document.addEventListener('DOMContentLoaded', () => {
    VP.initializeQuantityControls();
    VP.updateGrandTotal();
  });
  document.addEventListener('shopify:section:load', () => {
    VP.initializeQuantityControls();
    VP.updateGrandTotal();
  });
})();